import type { Color } from "../../types";
import type { HasAverageColor } from "../HasAverageColor";
import type { HasBackgroundColor } from "../HasBackgroundColor";
import type { VirtualViewportPixelAccessor } from "../VirtualViewportPixelAccessor";
import { AbstractVirtualPixelDecorator } from "./AbstractVirtualPixelDecorator";

/**
 * Constant color virtual pixel decorator.
 */
export class ConstantVirtualPixel<
  DecoratedType extends VirtualViewportPixelAccessor &
    HasAverageColor &
    HasBackgroundColor
> extends AbstractVirtualPixelDecorator<DecoratedType> {
  constructor(decorated: DecoratedType, protected color: Color) {
    super(decorated);
  }

  /**
   * @inheritDoc
   */
  getVirtualPixelColor(): Color {
    return this.color;
  }
}
